import {createContext} from "react";
import {IAccountRecordingsContext} from "../models/Account/IAccountRecordingsContext.ts";
import {IRecording} from "../../interfaces/account/recording/IRecording.ts";
import {IRecordingDto} from "../../response/account/getMeResponse.ts";

export const AccountRecordingsContext = createContext<IAccountRecordingsContext>({
    recordings: {} as IRecording,
    delete(id: number): Promise<void> {
        id;
        return Promise.resolve(undefined);
    },
    getAll(): Promise<void> {
        return Promise.resolve(undefined);
    },
    updateRecordingsBasic(recordings: IRecordingDto[]): void {
        recordings;
    }
});